import React, { useState, useEffect } from 'react';
import dpimg from "assets/img/dpmain.png";

const SightingModal = ({ isOpen, onClose, sightingFeeds = [], initialIndex = 0 }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [liked, setLiked] = useState(false);
  const [following, setFollowing] = useState(false);

  // Reset currentIndex when modal opens with new data
  useEffect(() => {
    if (isOpen) {
      setCurrentIndex(initialIndex);
      setLiked(false);
      setFollowing(false);
    }
  }, [isOpen, initialIndex]);

  if (!isOpen || !Array.isArray(sightingFeeds) || sightingFeeds.length === 0) return null;

  const currentFeed = sightingFeeds[currentIndex];

  const handleNext = () => {
    if (currentIndex < sightingFeeds.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const toggleLike = () => {
    setLiked(!liked);
  };

  const toggleFollow = () => {
    setFollowing(!following);
  };

  if (!currentFeed) return null;

  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    modal: {
      width: '850px',
      maxWidth: '90vw',
      height: '85vh',
      maxHeight: '700px',
      backgroundColor: 'black',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
    },
    contentContainer: {
      height: 'calc(83vh - 60px)',
      position: 'relative',
      backgroundColor: 'black'
    },
    media: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      backgroundColor: 'black',
      margin : 'auto'
    },
    navigationDots: {
      position: 'absolute',
      top: '16px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '4px'
    },
    dot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.5)'
    },
    activeDot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: 'white'
    },
    sideActions: {
      position: 'absolute',
      right: '16px',
      bottom: '120px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px'
    },
    actionButton: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      cursor: 'pointer',
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      transition: 'all 0.2s ease'
    },
    likedButton: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      cursor: 'pointer',
      backgroundColor: '#dc3545',
      transition: 'all 0.2s ease'
    },
    actionCount: {
      color: 'white',
      fontSize: '14px',
      marginTop: '4px',
      fontWeight: '500'
    },
    userOverlay: {
      position: 'absolute',
      bottom: '65px',
      left: '16px',
      right: '83px',
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      padding: '14px',
      borderRadius: '8px',
      backdropFilter: 'blur(10px)'
    },
    userInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '6px'
    },
    avatar: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      border: '2px solid white',
      objectFit: 'cover'
    },
    userName: {
      color: 'white',
      fontWeight: '600',
      fontSize: '16px',
      marginBottom: '4px'
    },
    userHandle: {
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: '14px'
    },
    followButton: {
      padding: '6px 18px',
      borderRadius: '20px',
      fontSize: '14px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'all 0.2s ease'
    },
    followingButton: {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      color: 'white',
      border: '1px solid rgba(255, 255, 255, 0.5)'
    },
    notFollowingButton: {
      backgroundColor: 'white',
      color: 'black'
    },
    animalLabel: {
      color: 'white',
      fontWeight: '600',
      marginBottom: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '16px'
    },
    location: {
      display: 'flex',
      alignItems: 'center',
      color: 'rgba(255, 255, 255, 0.9)',
      fontSize: '14px',
      marginBottom: '8px'
    },
    description: {
      color: 'white',
      fontSize: '14px',
      opacity: 0.9,
      lineHeight: '1.4'
    },
    moreButton: {
      position: 'absolute',
      top: '16px',
      right: '16px',
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      cursor: 'pointer'
    },
    navigationControls: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex'
    },
    navButton: {
      flex: 1,
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      zIndex: 10
    }
  };

  return (
    <div style={modalStyles.overlay}>

      <div style={modalStyles.modal}>

        <div className="d-flex align-items-center justify-content-between px-3 py-3 bg-white border-bottom">
          <h1 className="h5 mb-0 fw-semibold text-dark d-flex align-items-center">
            <i className="fas fa-binoculars me-2 text-success"></i>
            Sighting Updates
          </h1>
          <div className="d-flex align-items-center gap-0">
            <button onClick={onClose} className="btn btn-light rounded-circle p-1" style={{ width: '32px', height: '32px' }}>
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>

        {/* Content Container */}
        <div style={modalStyles.contentContainer}>
          {/* Media Content */}
          <div className="w-100 h-100 position-relative mx-auto">
            {currentFeed.feed?.full_file_path?.includes('.mp4') ? (
              <video
                style={modalStyles.media}
                controls
                autoPlay
                muted
                loop
                playsInline
                src={currentFeed.feed?.full_file_path}
              />
            ) : (
              <img
                style={modalStyles.media}
                src={currentFeed.feed?.thumbnail || currentFeed.feed?.full_file_path}
                alt={currentFeed.feed?.animal_label || 'Sighting'}
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1564349683136-77e08dba1ef7?w=400&h=600&fit=crop';
                }}
              />
            )}

            {/* Navigation Dots */}
            {sightingFeeds.length > 1 && (
              <div style={modalStyles.navigationDots}>
                {sightingFeeds.map((_, idx) => (
                  <div
                    key={idx}
                    style={idx === currentIndex ? modalStyles.activeDot : modalStyles.dot}
                  />
                ))}
              </div>
            )}

            {/* Side Actions */}
            <div style={{ ...modalStyles.sideActions, rowGap: '4px' }}>
                <div className="d-flex flex-column align-items-center" style={{ rowGap: '2px' }}>
                    <button
                    onClick={toggleLike}
                    style={{
                        ...(!liked ? modalStyles.actionButton : modalStyles.likedButton),
                        padding: '2px',
                        lineHeight: 1,
                    }}
                    onMouseEnter={(e) => {
                        if (!liked) e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                        if (!liked) e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
                    }}
                    >
                    <i className={liked ? "fas fa-heart text-white" : "far fa-heart text-white"} style={{ fontSize: '21px' }}></i>
                    </button>
                    <span style={{ fontSize: '14px', lineHeight: 1, margin: 0, color:"white" }}>
                    {(currentFeed.feed?.likes_count || 15) + (liked ? 1 : 0)}
                    </span>
                </div>

                <div className="d-flex flex-column align-items-center" style={{ rowGap: '2px' }}>
                    <button
                    style={{
                        ...modalStyles.actionButton,
                        padding: '2px',
                        lineHeight: 1,
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.3)'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.2)'}
                    >
                    <i className="far fa-comment text-white" style={{ fontSize: '21px' }}></i>
                    </button>
                    <span style={{ fontSize: '14px', lineHeight: 1, margin: 0, color: "white" }}>
                    {currentFeed.feed?.comments_count || 1}
                    </span>
                </div>

                <div className="d-flex flex-column align-items-center" style={{ rowGap: '2px' }}>
                    <button
                    style={{
                        ...modalStyles.actionButton,
                        padding: '2px',
                        lineHeight: 1,
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.3)'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.2)'}
                    >
                    <i className="fas fa-ellipsis-v text-white" style={{ fontSize: '21px' }}></i>
                    </button>
                </div>
            </div>


            {/* User Info Overlay */}
            <div style={modalStyles.userOverlay}>
              <div style={modalStyles.userInfo}>
                <img
                  src={currentFeed.feed?.sighting_user_detail?.image || dpimg}
                  alt={currentFeed.feed?.sighting_user_detail?.name || 'User'}
                  style={modalStyles.avatar}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = dpimg;
                  }}
                />
                <div className="flex-grow-1">
                    <div className="d-flex align-items-center justify-content-between mb-1">
                        <div>
                            <p style={modalStyles.userName} className='mb-0'>
                                {currentFeed.feed?.sighting_user_detail?.name || ''}
                            </p>
                            <span style={modalStyles.userHandle} >
                                @{currentFeed.feed?.sighting_user_detail?.subtitle || ''}
                            </span>
                        </div>

                        <button
                        onClick={toggleFollow}
                        className="ms-auto "
                        style={
                            following
                            ? { ...modalStyles.followButton, ...modalStyles.followingButton }
                            : { ...modalStyles.followButton, ...modalStyles.notFollowingButton }
                        }
                        >
                            {following ? 'Following' : 'Follow'}
                        </button>
                    </div>

                    
                </div>
              </div>

              <div style={modalStyles.animalLabel}>
                {currentFeed.feed?.animal_label || ''} sighting
              </div>
              
              <div style={modalStyles.location}>
                <i className="fas fa-map-marker-alt me-2" style={{ fontSize: '14px'}}></i>
                <span>{currentFeed.feed?.location_name || ''}</span>
              </div>
            </div>

           {/*Navigation Buttons (visible)*/}
            {sightingFeeds.length > 1 && (
            <>
                <button
                onClick={handlePrev}
                disabled={currentIndex === 0}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '8px',
                    transform: 'translateY(-60%) translateX(-20%)',
                    zIndex: 20,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    cursor: currentIndex === 0 ? 'not-allowed' : 'pointer',
                    opacity: currentIndex === 0 ? 0.4 : 1,
                }}
                >
                <i className="fas fa-chevron-left"></i>
                </button>

                <button
                onClick={handleNext}
                disabled={currentIndex === sightingFeeds.length - 1}
                style={{
                    position: 'absolute',
                    top: '50%',
                    right: '8px',
                    transform: 'translateY(-60%) translateX(20%)',
                    zIndex: 20,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    cursor: currentIndex === sightingFeeds.length - 1 ? 'not-allowed' : 'pointer',
                    opacity: currentIndex === sightingFeeds.length - 1 ? 0.4 : 1,
                }}
                >
                <i className="fas fa-chevron-right"></i>
                </button>
            </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SightingModal;